export default "__VITE_ASSET__C5ZiS28j__"